module.exports = __webpack_public_path__ + "img/tips.c40b64dd.png";